(() => {
  const ICON_PLAY = '<svg aria-label="Reproduzir" fill="currentColor" role="img" viewBox="0 0 48 48" focusable="false"><path d="M9 4.6v38.8c0 2.2 2.4 3.6 4.3 2.5l31.1-19.4a3 3 0 0 0 0-5L13.3 2.1C11.4 1 9 2.4 9 4.6Z"></path></svg>';
  const ICON_PAUSE = '<svg aria-label="Pausar" fill="currentColor" role="img" viewBox="0 0 48 48" focusable="false"><path d="M15 1c-3.3 0-6 1.3-6 3v40c0 1.7 2.7 3 6 3s6-1.3 6-3V4c0-1.7-2.7-3-6-3zm18 0c-3.3 0-6 1.3-6 3v40c0 1.7 2.7 3 6 3s6-1.3 6-3V4c0-1.7-2.7-3-6-3z"></path></svg>';
  const ICON_SOUND_ON = '<svg aria-label="O áudio está ativado" fill="currentColor" role="img" viewBox="0 0 48 48" focusable="false"><path d="M24.2 2.7c-.9-.6-2.1-.5-2.9.3L10.7 13.6H4.1A4.1 4.1 0 0 0 0 17.7v12.6a4.1 4.1 0 0 0 4.1 4.1h6.6L21.3 45c.8.8 2 .9 2.9.3.9-.4 1.4-1.3 1.4-2.3V5c0-1-.5-1.9-1.4-2.3Z"></path><path d="M33.4 14.2a14.2 14.2 0 0 1 0 19.6" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round"></path><path d="M39.4 8.3a22.8 22.8 0 0 1 0 31.4" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round"></path></svg>';
  const ICON_SOUND_OFF = '<svg aria-label="O áudio está silenciado" fill="currentColor" role="img" viewBox="0 0 48 48" focusable="false"><path clip-rule="evenodd" d="M1.5 13.3c-.8 0-1.5.7-1.5 1.5v18.4c0 .8.7 1.5 1.5 1.5h8.7l12.9 12.9c.9.9 2.5.3 2.5-1v-9.8c0-.4-.2-.8-.4-1.1l-22-22c-.3-.3-.7-.4-1.1-.4h-.6zm46.8 31.4-5.5-5.5C44.9 36.6 48 31.4 48 24c0-11.4-7.2-17.4-7.2-17.4-.6-.6-1.6-.6-2.2 0L37.2 8c-.6.6-.6 1.6 0 2.2 0 0 5.7 5 5.7 13.8 0 5.4-2.1 9.3-3.8 11.6L35.5 32c1.1-1.7 2.3-4.4 2.3-8 0-6.8-4.1-10.3-4.1-10.3-.6-.6-1.6-.6-2.2 0l-1.4 1.4c-.6.6-.6 1.6 0 2.2 0 0 2.6 2 2.6 6.7 0 1.8-.4 3.2-.9 4.3L25.5 22V1.4c0-1.3-1.6-1.9-2.5-1L13.5 10 3.3-.3c-.6-.6-1.5-.6-2.1 0L-.2 1.1c-.6.6-.6 1.5 0 2.1L4 7.6l26.8 26.8 13.9 13.9c.6.6 1.5.6 2.1 0l1.4-1.4c.7-.6.7-1.6.1-2.2z" fill-rule="evenodd"></path></svg>';

  class CaleoMediaShowcase {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-caleo-media-track]');
      this.cards = Array.from(section.querySelectorAll('[data-caleo-media-card]'));
      this.dots = Array.from(section.querySelectorAll('[data-caleo-media-dot]'));
      this.modal = section.querySelector('[data-caleo-media-modal]');
      this.modalDialog = this.modal ? this.modal.querySelector('[data-caleo-media-modal-dialog]') : null;
      this.modalInner = this.modal ? this.modal.querySelector('[data-caleo-media-modal-inner]') : null;
      this.modalTitle = this.modal ? this.modal.querySelector('[data-caleo-modal-title]') : null;
      this.modalSubtitle = this.modal ? this.modal.querySelector('[data-caleo-modal-subtitle]') : null;
      this.modalAvatar = this.modal ? this.modal.querySelector('[data-caleo-modal-avatar]') : null;
      this.modalVerified = this.modal ? this.modal.querySelector('[data-caleo-modal-verified]') : null;
      this.defaultModalAvatarHTML = this.modalAvatar ? this.modalAvatar.innerHTML : '';
      this.modalPlay = this.modal ? this.modal.querySelector('[data-caleo-modal-play]') : null;
      this.modalSound = this.modal ? this.modal.querySelector('[data-caleo-modal-sound]') : null;
      this.modalSurface = this.modal ? this.modal.querySelector('[data-caleo-modal-surface]') : null;
      this.modalProgressTrack = this.modal ? this.modal.querySelector('[data-caleo-modal-progress-track]') : null;
      this.modalProgress = this.modal ? this.modal.querySelector('[data-caleo-modal-progress]') : null;
      this.modalProgressPreview = this.modal ? this.modal.querySelector('[data-caleo-modal-progress-preview]') : null;
      this.modalProgressThumb = this.modal ? this.modal.querySelector('[data-caleo-modal-progress-thumb]') : null;
      this.modalProgressTooltip = this.modal ? this.modal.querySelector('[data-caleo-modal-progress-tooltip]') : null;
      this.modalFeedback = this.modal ? this.modal.querySelector('[data-caleo-modal-feedback]') : null;
      this.activeDelay = Number(section.dataset.activeDelay || 5000);
      this.autoplayDelay = Number(section.dataset.autoplayDelay || 10000);
      this.autoplayEnabled = section.dataset.autoplay === 'true';
      this.loopEnabled = section.dataset.loop === 'true';
      this.activeIndex = 0;
      this.timer = null;
      this.hoverTimer = null;
      this.scrollEndTimer = null;
      this.raf = null;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchStartIndex = 0;
      this.touchMoved = false;
      this.modalVideo = null;
      this.feedbackTimer = null;
      this.progressPointerDown = false;
      this.progressPreviewTimer = null;
      this.wasVisible = true;
      this.prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.saveData = navigator.connection && navigator.connection.saveData;

      if (!this.track || !this.cards.length) return;

      this.track.style.touchAction = 'auto';
      this.mountModal();
      this.prepareCards();
      this.bindCardClicks();
      this.bindHover();
      this.bindMobileTouch();
      this.bindScroll();
      this.bindDots();
      this.bindModal();
      this.bindVisibility();
      this.setActiveCard(0, false, true);
      this.startAutoplay();
    }

    isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    mountModal() {
      if (!this.modal || this.modal.parentNode === document.body) return;

      const style = window.getComputedStyle(this.section);

      ['--caleo-media-accent', '--caleo-media-heading', '--caleo-media-text'].forEach((prop) => {
        const value = style.getPropertyValue(prop);
        if (value) this.modal.style.setProperty(prop, value.trim());
      });

      document.body.appendChild(this.modal);
    }

    prepareCards() {
      this.cards.forEach((card) => {
        const media = card.querySelector('.caleo-media-showcase__media');
        const video = card.querySelector('[data-caleo-card-video]');
        const playButton = card.querySelector('.caleo-media-showcase__play');

        if (media) {
          media.classList.toggle('has-play-button', Boolean(playButton));
          media.classList.toggle('has-card-video', Boolean(video));
        }

        if (!video) return;

        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.preload = 'none';

        const clearLoading = () => {
          video.dataset.caleoVideoLoaded = 'true';
          if (media) media.classList.remove('is-media-loading');
        };

        const maybeLoading = () => {
          if (!media) return;
          if (Number(card.dataset.index) !== this.activeIndex) return;
          if (media.classList.contains('has-play-button')) return;
          if (video.readyState < 3) media.classList.add('is-media-loading');
        };

        video.addEventListener('loadstart', maybeLoading);
        video.addEventListener('waiting', maybeLoading);
        video.addEventListener('stalled', maybeLoading);
        video.addEventListener('loadedmetadata', clearLoading);
        video.addEventListener('loadeddata', clearLoading);
        video.addEventListener('canplay', clearLoading);
        video.addEventListener('playing', clearLoading);
        video.addEventListener('error', clearLoading);
      });
    }

    bindVisibility() {
      if (!('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.wasVisible = entry.isIntersecting;

          if (entry.isIntersecting) {
            this.playActiveVideo();
            this.startAutoplay();
          } else {
            this.stopAutoplay();
            this.pauseAllCardVideos();
          }
        });
      }, { threshold: 0.22 });

      observer.observe(this.section);
    }

    bindCardClicks() {
      this.section.addEventListener('click', (event) => {
        const openButton = event.target.closest('[data-caleo-media-open]');
        const openCard = event.target.closest('[data-caleo-media-card][data-open-modal="true"]');

        if (!openButton && !openCard) return;
        if (event.target.closest('a') && !openButton) return;
        if (this.touchMoved && !openButton) return;

        const card = openButton ? openButton.closest('[data-caleo-media-card]') : openCard;
        if (!card) return;

        event.preventDefault();
        this.openModal(card);
      });
    }

    bindHover() {
      this.cards.forEach((card, index) => {
        card.addEventListener('mouseenter', () => {
          if (this.isMobile()) return;

          window.clearTimeout(this.hoverTimer);
          this.hoverTimer = window.setTimeout(() => {
            this.setActiveCard(index, false, true);
            this.restartAutoplay();
          }, 80);
        });
      });
    }

    bindMobileTouch() {
      this.track.addEventListener('touchstart', (event) => {
        if (!this.isMobile() || !event.touches.length) return;

        this.touchMoved = false;
        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
        this.touchStartIndex = this.activeIndex;
        this.stopAutoplay();
        this.pauseAllCardVideos();
      }, { passive: true });

      this.track.addEventListener('touchmove', (event) => {
        if (!this.isMobile() || !event.touches.length) return;

        const diffX = event.touches[0].clientX - this.touchStartX;
        const diffY = event.touches[0].clientY - this.touchStartY;

        if (Math.abs(diffX) > 8 && Math.abs(diffX) > Math.abs(diffY)) {
          this.touchMoved = true;
        }

        this.scheduleScrollSync(false);
      }, { passive: true });

      this.track.addEventListener('touchend', (event) => {
        if (!this.isMobile()) return;

        const changedTouch = event.changedTouches && event.changedTouches[0];
        const diffX = changedTouch ? changedTouch.clientX - this.touchStartX : 0;
        const threshold = 46;

        if (this.loopEnabled && this.touchMoved) {
          if (this.touchStartIndex === this.cards.length - 1 && diffX < -threshold) {
            this.setActiveCard(0, true, true);
            this.restartAutoplay();
            window.setTimeout(() => {
              this.touchMoved = false;
            }, 120);
            return;
          }

          if (this.touchStartIndex === 0 && diffX > threshold) {
            this.setActiveCard(this.cards.length - 1, true, true);
            this.restartAutoplay();
            window.setTimeout(() => {
              this.touchMoved = false;
            }, 120);
            return;
          }
        }

        this.scheduleScrollSync(true);

        window.setTimeout(() => {
          this.touchMoved = false;
        }, 160);

        this.restartAutoplay();
      }, { passive: true });
    }

    bindScroll() {
      this.track.addEventListener('scroll', () => {
        this.scheduleScrollSync(false);
      }, { passive: true });

      if ('onscrollend' in window) {
        this.track.addEventListener('scrollend', () => this.syncFromScroll(true), { passive: true });
      }

      window.addEventListener('resize', () => {
        this.setActiveCard(this.getClosestIndex(), this.isMobile(), true);
      });
    }

    scheduleScrollSync(playWhenSettled) {
      if (this.raf) window.cancelAnimationFrame(this.raf);

      this.raf = window.requestAnimationFrame(() => {
        const index = this.getClosestIndex();
        this.setActiveDot(index);
        this.cards.forEach((card, cardIndex) => {
          card.classList.toggle('is-active', cardIndex === index);
        });
      });

      window.clearTimeout(this.scrollEndTimer);

      this.scrollEndTimer = window.setTimeout(() => {
        this.syncFromScroll(playWhenSettled);
      }, playWhenSettled ? 120 : 180);
    }

    syncFromScroll(playVideo) {
      const index = this.getClosestIndex();

      this.activeIndex = index;
      this.cards.forEach((card, cardIndex) => {
        card.classList.toggle('is-active', cardIndex === index);
      });
      this.setActiveDot(index);

      if (this.isMobile()) {
        this.scrollToCard(index);
      }

      if (playVideo) {
        window.setTimeout(() => this.playActiveVideo(), this.isMobile() ? 120 : 0);
      } else {
        this.pauseInactiveVideos(index);
      }
    }

    bindDots() {
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.caleoMediaDot || 0);
          this.setActiveCard(index, true, true);
          this.restartAutoplay();
        });
      });
    }

    bindModal() {
      if (!this.modal || !this.modalInner) return;

      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) {
          event.preventDefault();
          this.closeModal();
        }
      });

      this.modal.querySelectorAll('[data-caleo-media-close]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.closeModal();
        });
      });

      const overlay = this.modal.querySelector('.caleo-media-modal__overlay');

      if (overlay) {
        overlay.addEventListener('click', (event) => {
          event.preventDefault();
          this.closeModal();
        });
      }

      if (this.modalDialog) {
        this.modalDialog.addEventListener('click', (event) => event.stopPropagation());
      }

      window.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.modal.classList.contains('is-open')) this.closeModal();
      });

      if (this.modalSurface) this.modalSurface.addEventListener('click', () => this.toggleModalVideo());
      if (this.modalPlay) this.modalPlay.addEventListener('click', () => this.toggleModalVideo());
      if (this.modalSound) this.modalSound.addEventListener('click', () => this.toggleModalSound());

      if (this.modalProgressTrack) {
        this.modalProgressTrack.addEventListener('pointerdown', (event) => this.startProgressSeek(event));
        window.addEventListener('pointermove', (event) => this.moveProgressSeek(event));
        window.addEventListener('pointerup', (event) => this.endProgressSeek(event));
        this.modalProgressTrack.addEventListener('pointermove', (event) => this.previewProgress(event));
        this.modalProgressTrack.addEventListener('pointerleave', () => this.clearProgressPreview());
      }
    }

    setActiveCard(index, scroll = false, force = false) {
      if (!this.cards.length) return;

      index = Math.max(0, Math.min(this.cards.length - 1, index));

      if (!force && index === this.activeIndex) {
        this.setActiveDot(index);
        if (scroll) this.scrollToCard(index);
        this.playActiveVideo();
        return;
      }

      this.activeIndex = index;

      this.cards.forEach((card, cardIndex) => {
        card.classList.toggle('is-active', cardIndex === index);
      });

      this.setActiveDot(index);

      if (scroll) this.scrollToCard(index);

      if (scroll && this.isMobile()) {
        window.setTimeout(() => this.playActiveVideo(), 260);
      } else {
        this.playActiveVideo();
      }
    }

    getClosestIndex() {
      const trackRect = this.track.getBoundingClientRect();
      const reference = this.isMobile() ? trackRect.left + (trackRect.width / 2) : trackRect.left;
      let closestIndex = 0;
      let closestDistance = Infinity;

      this.cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const cardReference = this.isMobile() ? rect.left + (rect.width / 2) : rect.left;
        const distance = Math.abs(cardReference - reference);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    scrollToCard(index) {
      const card = this.cards[index];
      if (!card) return;

      const trackWidth = this.track.clientWidth;
      const cardWidth = card.offsetWidth;
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      let target = card.offsetLeft;

      if (this.isMobile() && index > 0) {
        target = card.offsetLeft - ((trackWidth - cardWidth) / 2);
      }

      if (this.isMobile() && index === 0) {
        target = 0;
      }

      target = Math.min(maxScroll, Math.max(0, target));
      this.track.scrollTo({ left: target, behavior: 'smooth' });
    }

    setActiveDot(index) {
      this.dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    }

    pauseInactiveVideos(activeIndex = this.activeIndex) {
      this.cards.forEach((card, index) => {
        if (index === activeIndex) return;

        const video = card.querySelector('[data-caleo-card-video]');
        const media = video ? video.closest('.caleo-media-showcase__media') : null;

        if (video) video.pause();
        if (media) media.classList.remove('is-media-loading');
      });
    }

    playActiveVideo() {
      if (!this.wasVisible) return;

      this.cards.forEach((card, index) => {
        const video = card.querySelector('[data-caleo-card-video]');
        if (!video) return;

        const media = video.closest('.caleo-media-showcase__media');
        const shouldAutoplay = video.dataset.caleoVideoAutoplay !== 'false';
        const shouldPlay = index === this.activeIndex && shouldAutoplay && !this.prefersReducedMotion && !this.saveData;

        if (shouldPlay) {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.preload = 'metadata';

          if (media && !media.classList.contains('has-play-button') && video.readyState < 3) {
            media.classList.add('is-media-loading');
          }

          const promise = video.play();

          if (promise && typeof promise.catch === 'function') {
            promise.catch(() => {
              if (media) media.classList.remove('is-media-loading');
            });
          }
        } else {
          video.pause();

          if (media) media.classList.remove('is-media-loading');

          if (!video.dataset.caleoVideoLoaded) {
            video.preload = 'none';
          }
        }
      });
    }

    pauseAllCardVideos() {
      this.cards.forEach((card) => {
        const video = card.querySelector('[data-caleo-card-video]');
        const media = video ? video.closest('.caleo-media-showcase__media') : null;

        if (video) video.pause();
        if (media) media.classList.remove('is-media-loading');
      });
    }

    startAutoplay() {
      if (!this.autoplayEnabled || this.cards.length <= 1 || this.timer || this.prefersReducedMotion) return;

      const delay = this.isMobile() ? this.autoplayDelay : this.activeDelay;

      this.timer = window.setInterval(() => {
        if (this.modal && this.modal.classList.contains('is-open')) return;
        if (!this.wasVisible) return;

        let next = this.activeIndex + 1;

        if (next >= this.cards.length) {
          if (!this.loopEnabled) {
            this.stopAutoplay();
            return;
          }

          next = 0;
        }

        this.setActiveCard(next, this.isMobile(), true);
      }, delay);
    }

    stopAutoplay() {
      if (!this.timer) return;

      window.clearInterval(this.timer);
      this.timer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    updateModalProfile(card) {
      const profileHandle = (card.dataset.modalProfileHandle || '').trim();
      const profileVerified = card.dataset.modalProfileVerified === 'true';
      const profileTemplate = card.querySelector('[data-caleo-modal-profile-template]');

      if (this.modalAvatar) {
        if (profileTemplate) {
          this.modalAvatar.innerHTML = '';
          this.modalAvatar.appendChild(profileTemplate.content.cloneNode(true));
        } else {
          this.modalAvatar.innerHTML = this.defaultModalAvatarHTML;
        }
      }

      if (profileHandle) {
        if (this.modalTitle) this.modalTitle.textContent = profileHandle.charAt(0) === '@' ? profileHandle : `@${profileHandle}`;
        if (this.modalSubtitle) {
          this.modalSubtitle.textContent = '';
          this.modalSubtitle.hidden = true;
        }
        if (this.modalVerified) {
          this.modalVerified.hidden = !profileVerified;
        }
        if (this.modal) this.modal.classList.add('has-profile-handle');
      } else {
        if (this.modalTitle) this.modalTitle.textContent = card.dataset.cardTitle || 'Vídeo do produto';
        if (this.modalSubtitle) {
          this.modalSubtitle.textContent = card.dataset.cardSubtitle || 'Detalhes do produto';
          this.modalSubtitle.hidden = false;
        }
        if (this.modalVerified) {
          this.modalVerified.hidden = true;
        }
        if (this.modal) this.modal.classList.remove('has-profile-handle');
      }
    }

    openModal(card) {
      const template = card.querySelector('[data-caleo-media-template]');
      if (!template || !this.modal || !this.modalInner) return;

      this.stopAutoplay();
      this.pauseAllCardVideos();

      this.modalInner.innerHTML = '';
      this.modalInner.appendChild(template.content.cloneNode(true));

      this.updateModalProfile(card);

      this.modalVideo = this.modalInner.querySelector('[data-caleo-modal-video], video');

      this.modal.classList.remove('is-paused', 'is-ended', 'is-loading', 'is-progress-previewing');
      this.setDefaultDialogSize();

      this.modal.hidden = false;
      this.modal.style.background = 'rgba(10, 10, 10, .88)';

      window.requestAnimationFrame(() => {
        this.modal.classList.add('is-open');
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('caleo-media-modal-open');
      });

      if (this.modalVideo) {
        this.modal.classList.add('is-loading');
        this.modalVideo.controls = false;
        this.modalVideo.defaultMuted = false;
        this.modalVideo.muted = false;
        this.modalVideo.removeAttribute('muted');
        this.modalVideo.volume = 1;
        this.modalVideo.playsInline = true;
        this.modalVideo.currentTime = 0;
        this.bindModalVideoEvents();
        this.updateModalIcons();

        const promise = this.modalVideo.play();

        if (promise && typeof promise.catch === 'function') {
          promise.catch(() => {
            this.modal.classList.add('is-paused');
            this.modal.classList.remove('is-loading');
            this.updateModalIcons();
          });
        }
      } else {
        this.hideVideoControlsForImage();

        const image = this.modalInner.querySelector('.caleo-media-modal__image');

        if (image) {
          if (image.complete) this.updateDialogAspect();
          image.addEventListener('load', () => this.updateDialogAspect(), { once: true });
        }
      }

      window.setTimeout(() => this.updateDialogAspect(), 80);
    }

    setDefaultDialogSize() {
      if (!this.modalDialog) return;

      const viewportW = window.innerWidth * 0.92;
      const viewportH = window.innerHeight * 0.88;
      const width = Math.min(viewportW, viewportH * (9 / 16), 420);
      const height = Math.min(viewportH, width / (9 / 16));

      this.modalDialog.style.setProperty('--caleo-modal-width', `${Math.round(width)}px`);
      this.modalDialog.style.setProperty('--caleo-modal-height', `${Math.round(height)}px`);
    }

    hideVideoControlsForImage() {
      if (this.modalProgressTrack) this.modalProgressTrack.style.display = 'none';
      if (this.modalPlay) this.modalPlay.style.display = 'none';
      if (this.modalSound) this.modalSound.style.display = 'none';
    }

    showVideoControls() {
      if (this.modalProgressTrack) this.modalProgressTrack.style.display = '';
      if (this.modalPlay) this.modalPlay.style.display = '';
      if (this.modalSound) this.modalSound.style.display = '';
    }

    bindModalVideoEvents() {
      if (!this.modalVideo) return;

      this.showVideoControls();

      const clearLoading = () => this.modal.classList.remove('is-loading');

      this.modalVideo.addEventListener('loadedmetadata', () => {
        this.updateDialogAspect();
        this.updateProgress();
      }, { once: true });
      this.modalVideo.addEventListener('timeupdate', () => this.updateProgress());
      this.modalVideo.addEventListener('progress', () => this.updateProgress());
      this.modalVideo.addEventListener('loadeddata', clearLoading);
      this.modalVideo.addEventListener('canplay', clearLoading);
      this.modalVideo.addEventListener('playing', () => {
        this.modal.classList.remove('is-loading', 'is-paused');
        this.updateModalIcons();
      });
      this.modalVideo.addEventListener('waiting', () => this.modal.classList.add('is-loading'));
      this.modalVideo.addEventListener('pause', () => {
        this.modal.classList.add('is-paused');
        this.updateModalIcons();
      });
      this.modalVideo.addEventListener('play', () => {
        this.modal.classList.remove('is-paused', 'is-ended');
        this.updateModalIcons();
      });
      this.modalVideo.addEventListener('ended', () => {
        this.modal.classList.add('is-ended');
        this.updateModalIcons();
        window.setTimeout(() => this.closeModal(), 650);
      });
    }

    updateDialogAspect() {
      if (!this.modalDialog) return;

      const video = this.modalVideo;
      const image = this.modalInner ? this.modalInner.querySelector('.caleo-media-modal__image') : null;
      let width = 0;
      let height = 0;

      if (video && video.videoWidth && video.videoHeight) {
        width = video.videoWidth;
        height = video.videoHeight;
      } else if (image && image.naturalWidth && image.naturalHeight) {
        width = image.naturalWidth;
        height = image.naturalHeight;
      }

      if (!width || !height) {
        this.setDefaultDialogSize();
        return;
      }

      const ratio = width / height;
      const viewportW = window.innerWidth * 0.92;
      const viewportH = window.innerHeight * 0.88;
      let maxWidth = 420;

      if (ratio > 1.25) maxWidth = 900;
      else if (ratio > 0.82) maxWidth = 620;

      let finalWidth = Math.min(viewportW, viewportH * ratio, maxWidth);
      let finalHeight = finalWidth / ratio;

      if (finalHeight > viewportH) {
        finalHeight = viewportH;
        finalWidth = finalHeight * ratio;
      }

      this.modalDialog.classList.toggle('is-horizontal', ratio > 1.25);
      this.modalDialog.classList.toggle('is-square', ratio <= 1.25 && ratio >= 0.82);
      this.modalDialog.classList.toggle('is-vertical', ratio < 0.82);
      this.modalDialog.style.setProperty('--caleo-modal-width', `${Math.round(finalWidth)}px`);
      this.modalDialog.style.setProperty('--caleo-modal-height', `${Math.round(finalHeight)}px`);
    }

    closeModal() {
      if (!this.modal || !this.modalInner) return;

      if (this.modalVideo) this.modalVideo.pause();

      this.modal.classList.remove('is-open', 'is-paused', 'is-ended', 'is-loading', 'is-progress-previewing');
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('caleo-media-modal-open');

      window.setTimeout(() => {
        if (!this.modal.classList.contains('is-open')) {
          this.modal.hidden = true;
          this.modalInner.innerHTML = '';
          this.modalVideo = null;
          this.showVideoControls();
          if (this.modalAvatar) this.modalAvatar.innerHTML = this.defaultModalAvatarHTML;
          if (this.modalVerified) this.modalVerified.hidden = true;
          if (this.modalSubtitle) this.modalSubtitle.hidden = false;
          if (this.modal) this.modal.classList.remove('has-profile-handle');
          this.playActiveVideo();
          this.startAutoplay();
        }
      }, 260);
    }

    toggleModalVideo() {
      if (!this.modalVideo) return;

      if (this.modalVideo.paused) {
        const promise = this.modalVideo.play();
        if (promise && typeof promise.catch === 'function') promise.catch(() => {});
        this.showFeedback(ICON_PLAY);
      } else {
        this.modalVideo.pause();
        this.showFeedback(ICON_PAUSE);
      }

      this.updateModalIcons();
    }

    toggleModalSound() {
      if (!this.modalVideo) return;

      this.modalVideo.muted = !this.modalVideo.muted;

      if (!this.modalVideo.muted) this.modalVideo.volume = 1;

      this.updateModalIcons();
    }

    updateModalIcons() {
      const playHolder = this.modal ? this.modal.querySelector('[data-caleo-modal-play-icon]') : null;
      const soundHolder = this.modal ? this.modal.querySelector('[data-caleo-modal-sound-icon]') : null;

      if (playHolder && this.modalVideo) playHolder.innerHTML = this.modalVideo.paused ? ICON_PLAY : ICON_PAUSE;

      if (soundHolder && this.modalVideo) {
        soundHolder.innerHTML = this.modalVideo.muted ? ICON_SOUND_OFF : ICON_SOUND_ON;
        if (this.modalSound) this.modalSound.setAttribute('aria-label', this.modalVideo.muted ? 'Ativar áudio' : 'Silenciar vídeo');
      }
    }

    showFeedback(icon) {
      if (!this.modalFeedback) return;

      window.clearTimeout(this.feedbackTimer);
      this.modalFeedback.innerHTML = icon;
      this.modalFeedback.classList.add('is-visible');
      this.feedbackTimer = window.setTimeout(() => this.modalFeedback.classList.remove('is-visible'), 340);
    }

    formatTime(seconds) {
      if (!Number.isFinite(seconds)) return '0:00';

      const minutes = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);

      return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
    }

    updateProgress() {
      if (!this.modalVideo || !this.modalProgress) return;

      const duration = this.modalVideo.duration || 0;
      const current = this.modalVideo.currentTime || 0;
      const percent = duration ? Math.min(100, Math.max(0, (current / duration) * 100)) : 0;
      const isPreviewing = this.progressPointerDown || (this.modal && this.modal.classList.contains('is-progress-previewing'));

      this.modalProgress.style.width = `${percent}%`;

      if (!isPreviewing) {
        if (this.modalProgressThumb) this.modalProgressThumb.style.left = `${percent}%`;
        if (this.modalProgressTooltip) this.modalProgressTooltip.textContent = `${this.formatTime(current)} / ${this.formatTime(duration)}`;
      }
    }

    getProgressPercent(event) {
      if (!this.modalProgressTrack) return 0;

      const rect = this.modalProgressTrack.getBoundingClientRect();
      const x = Math.min(rect.right, Math.max(rect.left, event.clientX));

      return rect.width ? ((x - rect.left) / rect.width) : 0;
    }

    startProgressSeek(event) {
      if (!this.modalVideo) return;

      this.progressPointerDown = true;
      this.modal.classList.add('is-progress-previewing');
      this.seekProgress(event);
    }

    moveProgressSeek(event) {
      if (!this.progressPointerDown || !this.modalVideo) return;

      this.seekProgress(event);
    }

    endProgressSeek(event) {
      if (!this.progressPointerDown) return;

      this.progressPointerDown = false;
      this.seekProgress(event);
      this.clearProgressPreview();
    }

    seekProgress(event) {
      if (!this.modalVideo || !this.modalVideo.duration) return;

      const percent = this.getProgressPercent(event);
      const percentValue = percent * 100;

      this.modalVideo.currentTime = percent * this.modalVideo.duration;

      if (this.modalProgressPreview) this.modalProgressPreview.style.width = `${percentValue}%`;
      if (this.modalProgressThumb) this.modalProgressThumb.style.left = `${percentValue}%`;
      if (this.modalProgressTooltip) {
        this.modalProgressTooltip.style.left = `${percentValue}%`;
        this.modalProgressTooltip.textContent = `${this.formatTime(this.modalVideo.currentTime)} / ${this.formatTime(this.modalVideo.duration)}`;
      }

      this.updateProgress();
    }

    previewProgress(event) {
      if (!this.modalVideo || !this.modalVideo.duration || !this.modalProgressPreview) return;

      const percent = this.getProgressPercent(event) * 100;

      this.modalProgressPreview.style.width = `${percent}%`;

      if (this.modalProgressThumb) this.modalProgressThumb.style.left = `${percent}%`;

      if (this.modalProgressTooltip) {
        this.modalProgressTooltip.style.left = `${percent}%`;
        this.modalProgressTooltip.textContent = `${this.formatTime((percent / 100) * this.modalVideo.duration)} / ${this.formatTime(this.modalVideo.duration)}`;
      }

      this.modal.classList.add('is-progress-previewing');
      window.clearTimeout(this.progressPreviewTimer);
    }

    clearProgressPreview() {
      if (this.progressPointerDown) return;

      window.clearTimeout(this.progressPreviewTimer);
      this.progressPreviewTimer = window.setTimeout(() => {
        if (this.modal) this.modal.classList.remove('is-progress-previewing');
        this.updateProgress();
      }, 140);
    }
  }

  const init = (container = document) => {
    container.querySelectorAll('[data-caleo-media-showcase]').forEach((section) => {
      if (section.dataset.caleoMediaReady === 'true') return;

      section.dataset.caleoMediaReady = 'true';
      new CaleoMediaShowcase(section);
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
